import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Grid, Divider } from '@mui/material';
import { School } from '@mui/icons-material';
import CourseCard from './CourseCard';

const CourseGrid = ({ 
  filteredCourses, 
  selectedYearFilter,
  isEnrolled, 
  validMembership, 
  canEnrollInCourse, 
  onEnroll 
}) => {
  // Determina il titolo del banner basato sul filtro selezionato
  const getBannerTitle = () => {
    switch (selectedYearFilter) {
      case '0':
        return 'Workshop & Festival';
      case '1':
        return 'Corsi 1° Anno';
      case '2':
        return 'Corsi 2° Anno';
      case '3':
        return 'Corsi 3° Anno';
      case 'post-triennio':
        return 'Corsi Post Triennio';
      default:
        return 'Corsi';
    }
  };

  if (!filteredCourses || filteredCourses.length === 0) {
    return (
      <Box sx={{ mb: 4 }}>
        <Typography 
          variant='h4' 
          sx={{ 
            mb: 3, 
            display: 'flex', 
            alignItems: 'center', 
            gap: 2,
            fontWeight: 700,
            color: 'primary.contrastText',
            borderBottom: '3px solid',
            borderColor: 'success.main',
            pb: 1,
            px: 2,
            py: 2,
            backgroundColor: 'success.main',
            borderRadius: 1,
            boxShadow: 2
          }}
        >
          <School sx={{ fontSize: 32 }} />
          {getBannerTitle()}
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          py: 4,
          flexDirection: 'column',
          gap: 1
        }}>
          <Typography variant='body1' color='text.secondary' textAlign='center'>
            Nessun corso pubblicato
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        variant='h4' 
        sx={{ 
          mb: 3, 
          display: 'flex', 
          alignItems: 'center', 
          gap: 2,
          fontWeight: 700,
          color: 'primary.contrastText',
          borderBottom: '3px solid',
          borderColor: 'success.main',
          pb: 1,
          px: 2,
          py: 2,
          backgroundColor: 'success.main',
          borderRadius: 1,
          boxShadow: 2
        }}
      >
        <School sx={{ fontSize: 32 }} />
        {getBannerTitle()}
      </Typography>
      <Divider sx={{ mb: 2 }} />
      <Grid container spacing={3} alignItems="stretch">
      {filteredCourses.map((course) => {
        const enrollment = isEnrolled(course._id);
        const isSuspendedEnrollment = enrollment?.status === 'suspended';

        return (
          <Grid size={{ xs: 12, md: 6, lg: 4 }} key={course._id} sx={{ display: 'flex' }}>
            <CourseCard
              course={course}
              enrollment={enrollment}
              isSuspendedEnrollment={isSuspendedEnrollment}
              onEnroll={onEnroll}
              validMembership={validMembership}
              canEnrollInCourse={canEnrollInCourse}
            />
          </Grid>
        );
      })}
      </Grid>
    </Box>
  );
};

CourseGrid.propTypes = {
  filteredCourses: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedYearFilter: PropTypes.string,
  isEnrolled: PropTypes.func.isRequired,
  validMembership: PropTypes.bool,
  canEnrollInCourse: PropTypes.func.isRequired,
  onEnroll: PropTypes.func.isRequired
};

export default CourseGrid;
